import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="bg-[#000] hidden sm:block">
      <div className="flex items-center justify-between gap-4 px-4 py-5 sm:px-8 lg:px-28">
        <img
          src="/img/webpImg/Tbd-White-Logo.webp"
          alt="White logo"
          className="w-[85px] lg:w-[95px]"
        />
        <p className="text-[#FFF] text-xs lg:text-sm">
          © {year} The Best Deals | All rights reserved. | Privacy Policy |
          Terms of Service
        </p>
        <div className="text-[#FFF] flex gap-2 md:gap-4">
          <img
            src="/img/webpImg/Tbd-instagram-Logo.webp"
            alt="Instagram"
            className="w-[25px] md:w-[28px]"
          />
          <img
            src="/img/webpImg/Tbd-facebook.webp"
            alt="Facebbok"
            className="w-[25px] md:w-[28px]"
          />
          <img
            src="/img/webpImg/Tbd-twitter.webp"
            alt="Twitter"
            className="w-[25px] md:w-[28px]"
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
